export class StatefulSetInterval {
    constructor(callback, millis){
        const functionBody = callback.toString().replace(/^[^{]*{\s*/, '').replace(/\s*}[^}]*$/, '');
        const worker = new Worker(URL.createObjectURL(
            new Blob([functionBody], { type: 'text/javascript' })
        ));
        worker.onmessage = async () => {
            await callback();
        };
        this.worker = worker;
        this.millis = millis;
    }

    start(){
        this.worker.postMessage({ action: 'start', millis: this.millis });
    }

    stop(){
        this.worker.postMessage({ action: 'stop' });
    }

    dispose(){
        this.worker.terminate();
    }
}

export function statefulSetInterval(computation, ...message) {
    const delegate = () => {
        let intervalId = undefined
        onmessage = ({ data: { millis, action } }) => {
            if (action === 'start') {
                setInterval(() => {
                    postMessage('fired');
                }, millis); 
            } else {
                clearInterval(intervalId);
            }

        };
    }
    const functionBody = delegate.toString().replace(/^[^{]*{\s*/, '').replace(/\s*}[^}]*$/, '');
    return new Promise((resolve, reject) => {
        const worker = new Worker(URL.createObjectURL(
            new Blob([functionBody], { type: 'text/javascript' })
        ));
        worker.onmessage = ({ data }) => {
            resolve(data);
            worker.terminate();
        };
        worker.onerror = worker.onmessageerror = reject;
        worker.postMessage({ computation: computation.toString(), message });
        return worker;
    });
}